import React from "react";
import PropTypes from "prop-types";
import Carousel from "./Carousel";
import CarouselStateHandler from "./CarouselStateHandler";

const CarouselWithIndex = (props) => (
  // eslint-disable-next-line react/destructuring-assignment
  <CarouselStateHandler slidesCount={React.Children.count(props.children)}>
    {({ ref, index, decrement, increment, handleScroll }) => (
      <Carousel
        // Acceptable use of props spreading here as this is just a wrapper.
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        ref={ref}
        index={index}
        decrement={decrement}
        increment={increment}
        handleScroll={handleScroll}
      />
    )}
  </CarouselStateHandler>
);

CarouselWithIndex.propTypes = {
  children: PropTypes.node,
  disableGradient: PropTypes.bool,
};

CarouselWithIndex.defaultProps = {
  children: null,
  disableGradient: false,
};

export default CarouselWithIndex;
